<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="footer">
    <div v-html="innerHtml"></div>
  </div>
</template>

<script>
import { getFooterHtml } from '@/api'
import $ from 'jquery'
export default {
  data() {
    return {
      innerHtml: '',
    }
  },
  mounted() {
    this.getFooterHtml()
  },
  methods: {
    async getFooterHtml() {
      const res = await getFooterHtml()
      if (res) {
        this.innerHtml = res
        // this.innerHtml = res.replace(
        //   /<link[^>]*rel=["']stylesheet["'][^>]*>/gi,
        //   ''
        // )
        $(function () {
          $('#footer-app').show()
          $('.relation').each(function () {
            $(this).click(function () {
              if ($(this).hasClass('show')) {
                $('.relation ul').eq($(this).index()).hide()
                $('.relation').eq($(this).index()).removeClass('show')
              } else {
                $('.relation ul').eq($(this).index()).show()
                $('.relation').eq($(this).index()).addClass('show')
              }
            })
          })
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('@/assets/style/common/common.css');
@import url('@/assets/style/common/global.css');
</style>
